<template>
  <div v-if="currentUser.superAdmin">
    <v-data-table
      :headers="headers"
      :items="recommendedByList"
      :options.sync="pagination"
      :server-items-length="totalRecommendedByList"
      :loading="loading"
      :footer-props="{
        'showFirstLastPage':true,
        'items-per-page-options': [10, 20, 50, 100]
      }"
      class="elevation-1"
    >
      <template v-slot:item.allCities="{ item }">
        <v-switch v-model="item.allCities" disabled></v-switch>
      </template>
      <template v-slot:item.clear="{ item }">
        <v-avatar v-if="currentUser.superAdmin || (!currentUser.superAdmin && !item.allCities)" color="teal" size="26" rounded>
          <router-link
            :to="{
              name: 'RecommendedByEdit',
              params: { recommendedById: item.id }
            }"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </router-link>
        </v-avatar>
      </template>
      <template v-slot:item.add="{ item }">
        <v-avatar v-if="currentUser.superAdmin || (!currentUser.superAdmin && !item.allCities)" color="red darken-4" size="26" rounded>
          <v-icon dark @click="delRecord(item)">mdi-delete</v-icon>
        </v-avatar>
      </template>
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-avatar color="indigo" size="30">
              <v-icon
                dark
                @click="
                  page = 1;
                  retrieveRecommendedByList();
                "
                >mdi-magnify
              </v-icon>
            </v-avatar>
          </td>
          <td>
            <router-link :to="{ name: 'RecommendedByCreate' }">
              <v-avatar color="teal" size="26" rounded>
                <v-icon dark>mdi-plus</v-icon>
              </v-avatar>
            </router-link>
          </td>
        </tr>
      </template>
    </v-data-table>
    <ConfirmDialog ref="confirm" />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ConfirmDialog from "@/view/pages/ConfirmDialog";
import {mapGetters} from "vuex";

export default {
  name: "recommendedByList",
  computed: {
    ...mapGetters(["currentUser"]),
    headers() {
      return [
        { text : "Id" , align : "start" , sortable : true , value : "id" } ,
        { text : this.$i18n.t('date.from') , value : "startDate" } ,
        { text : this.$i18n.t('date.to') , value : "endDate" } ,
        { text : this.$i18n.t('pages.recommendedCategories.allCities') , value : "allCities" } ,
        { text : this.$i18n.t('commonTable.cities') , value : "cityName" } ,
        { text : this.$i18n.t('common.shops') , value : "shopIds" } ,
        { text : this.$i18n.t('common.type') , value : "type" } ,
        { text : "" , value : "search" , width : "5%" } ,
        { text : "" , value : "clear" , width : "5%" } ,
        { text : "" , value : "add" , width : "5%" }
      ]
    }
  },
  data() {
    return {
      totalRecommendedByList: 0,
      recommendedByList: [],
      loading: true,
      pagination: {},
      showEditRecommendedByDialog: false,
      citiesList: [],
      shopsList: [],
      sponsorList: [],
      dialogDelete: false,
      itemToDelete: null,
      errors: []
    };
  },
  watch: {
    pagination: {
      handler() {
        this.retrieveRecommendedByList();
      },
      deep: true
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Recommended By" }]);
  },
  components: {
    ConfirmDialog
  },
  methods: {
    async delRecord(item) {
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('common.confirm'),
          this.$i18n.t('pages.recommendedBy.deleteMessage') +
            item.id +
            " ?"
        )
      ) {
        this.deleteRecord(item);
      }
    },
    deleteRecord(item) {
      this.deleteRecommendedBy(item.id);
    },
    deleteRecommendedBy(recommendedBy) {
      this.loading = true;
      ApiService.delete(`api/recommended-shops/${recommendedBy}`)
        .then(response => {
          this.$log.debug("Recommended by deleted: ", response);
          this.retrieveRecommendedByList();
        })
        .catch(error => {
          this.$log.error("Error: ", error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getRequestParams() {
      let params = {};

      params["type"] = "RECOMMENDED_BY";

      let sort;
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      if (sortBy.length === 1 && sortDesc.length === 1) {
        sort = sortBy[0];
        if (sortDesc[0] === true) sort += ",desc";
      }
      params["sort"] = sort;
      params["page"] = this.pagination.page;
      params["size"] = this.pagination.itemsPerPage;

      return params;
    },
    retrieveRecommendedByList() {
      const params = this.getRequestParams();
      return new Promise(resolve => {
        this.loading = true;
        ApiService.query("api/recommended-shops", {
          params
        }).then(response => {
          // JSON responses are automatically parsed.
          this.$log.debug("RecommendedByList: ", response.data.content);
          this.recommendedByList = response.data.content;
          this.totalRecommendedByList = response.data.totalElements;
          this.totalPages = response.data.totalPages;
          this.loading = false;
          let title =
            this.totalRecommendedByList != null
              ? this.totalRecommendedByList
              : 0;
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Recommended by: " + title }
          ]);
          resolve();
        });
      });
    }
  }
};
</script>

<style>
.v-data-table.v-data-table.v-data-table >>> td {
  font-size: 16px;
}
.v-icon.v-icon {
  font-size: 24px !important;
}
tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}
</style>
